
























import { SavedAdvertsModule } from '@app/componentlib/src/store/modules/JobMatch/savedAdverts'
import Vue from 'vue'
import Component from 'vue-class-component'
import JobViewContainer from '@app/componentlib/src/views/components/job-components/JobViewContainer.vue'
import { IResultPage } from '@app/componentlib/common/types/JobMatchTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { IJobPosting } from '@app/componentlib/common/types/JobSearchTypes'
import MobileButtonBottom from '@app/componentLib/src/views/components/shared/MobileButtonBottom.vue'

@Component<Favorites>({
  props: {
    content: Object
  },
  components: {
    JobViewContainer,
    MobileButtonBottom
  }
})

export default class Favorites extends Vue {
  /**
   * Props variables
   */
  content: IResultPage | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */

  /**
   * Getters
   */
  get savedAdverts() {
    return SavedAdvertsModule.savedAdverts
  }

  get isMobile(): boolean {
    return AppModule.isMobile
  }

  get selectedJobPosting(): IJobPosting | undefined {
    return SavedAdvertsModule.selectedJobPosting
  }

  get activeIndex (): Number {
    return SavedAdvertsModule.activeIndex
  }

  /**
   * Methods
   */

   async setSelectedJobPosting(posting: IJobPosting) {
    SavedAdvertsModule.setSelectedJobPosting(posting)
  }

  async setActiveIndex(index: number) {
    SavedAdvertsModule.setActiveIndex(index)
  }

}
